<div class="oauth-buttons-container" *ngIf="!isLoading">
  <!-- Separador visual si hay proveedores OAuth -->
  <div class="oauth-separator" *ngIf="isOAuthEnabled && oauthProviders.length > 0">
    <span class="oauth-separator-text">o</span>
  </div>

  <!-- Botones OAuth -->
  <div class="oauth-buttons" *ngIf="isOAuthEnabled && oauthProviders.length > 0">
    <button
      *ngFor="let provider of oauthProviders"
      type="button"
      [class]="getProviderButtonClass(provider)"
      [ngStyle]="getProviderButtonStyle(provider)"
      [disabled]="!provider.enabled"
      (click)="loginWithProvider(provider)"
      [attr.aria-label]="'Continuar con ' + provider.display_name"
    >
      <!-- Icono del proveedor -->
      <i [class]="getProviderIcon(provider)" aria-hidden="true"></i>
      
      <!-- Texto del botón -->
      <span class="oauth-button-text">
        Continuar con {{ provider.display_name }}
      </span>
    </button>
  </div>

  <!-- Estado de carga -->
  <div class="oauth-loading" *ngIf="isLoading">
    <div class="spinner"></div>
    <span>Cargando opciones de acceso...</span>
  </div>

  <!-- Mensaje cuando OAuth está deshabilitado -->
  <div class="oauth-disabled" *ngIf="!isOAuthEnabled && !isLoading">
    <!-- Solo mostrar esto si se quiere debuggear -->
    <!-- <small class="text-muted">OAuth está deshabilitado</small> -->
  </div>
</div>